import { useContext, useState } from 'react';
import { FilterContext } from 'utils/context';

import {
  IBasicInventoryOrderSearchCriteria,
  IOrderSearch,
} from '@project44-models/shipment-list';

import { fetchOrders, getCount as getCountFetch } from './fetchOrders';

const defaultData: IOrderSearch = {
  results: [],
  paginationInfo: {
    total: 0,
    pageSize: 1,
    pageNumber: 1,
  },
};

function useSearchOrders() {
  const [data, setData] = useState(defaultData);
  const [totalCount, setTotalCount] = useState(0);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { getOrdersRequest } = useContext(FilterContext);

  const getCount = async (body?: IBasicInventoryOrderSearchCriteria) => {
    return await getCountFetch(body).catch(() => 0);
  };

  const doCount = async () => {
    try {
      const total = await getCount();
      setTotalCount(total);
    } catch {}
  };

  const doSearch = async (pagination?: { page: number; size: number }) => {
    // TODO fix: sort does not exist on type IBasicInventoryOrderSearchCriteria
    // but is tagging along here until alignment on the backend
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { sort, ...post } = getOrdersRequest() as any;
    const body = {
      ...post,
      sort,
      pagination: {
        pageNumber: pagination?.page || 1,
        pageSize: pagination?.size || 20,
      },
    };

    setIsError(false);
    setIsLoading(true);
    await fetchOrders(body)
      .then((response) => {
        setData(response);
        setIsLoading(false);
      })
      .catch(() => {
        setData(defaultData);
        setIsError(true);
        setIsLoading(false);
      });
  };

  return {
    data,
    doCount,
    doSearch,
    getCount,
    isError,
    isLoading,
    totalCount,
  };
}

export default useSearchOrders;
